import * as React from 'react';
import { useDispatch } from 'react-redux';

import { GeoLocationButton } from './GeoLocationButton';
import { pushErrorNotification } from '../../../../../../common/actions/notifications';
import { useApplicationContext } from '../../../../../../common/containers/ApplicationContext';
import { EErrorNotificationType } from '../../../../../../common/types/notifications';
import { useMapContext } from '../../../context';

export const GeoLocationButtonContainer: React.FC = props => {
  const dispatch = useDispatch();
  const { map, ymaps } = useMapContext();
  const { logger } = useApplicationContext();

  const handleGeoLocationError = React.useCallback(
    (error: Error) => {
      logger.error(error, { domain: 'Controls/GeoLocationButton/handleGeoLocationClick()' });

      dispatch(pushErrorNotification(EErrorNotificationType.GeoLocation));
    },
    [logger, dispatch],
  );

  return <GeoLocationButton {...props} map={map} ymaps={ymaps} onGeoLocationError={handleGeoLocationError} />;
};
